import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null};
  }
  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true, error, info});
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return [
        <h1>Oops! Something went wrong.</h1>,
        <p>`${this.state.error + this.state.info}`</p>
      ];
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/utils/ErrorBoundary.js